import React, { Component } from 'react';

// Sección "Experiencia Profesional" como línea de tiempo horizontal (izquierda → derecha).
// Orden: de más reciente (2024) a más antiguo (1999). Consolida la trayectoria del CV en un
// único arreglo (antes vivía en chapters/ContainerLeft.jsx y ContainerMid.jsx).
// `destacado` marca el logro IMCO.

class Chapter extends Component {
    constructor(props){
        super(props);
        this.state = {
            trayectoria: [
                {
                    id: 1,
                    periodo: '2024 – actual',
                    cargo: 'Regidora Municipal',
                    organo: 'Mineral de la Reforma, Hidalgo',
                    texto: 'Integrante de la Comisión Permanente de Hacienda; supervisión del ejercicio del gasto público y trabajo en comisiones estratégicas en el Cabildo.'
                },
                {
                    id: 2,
                    periodo: '2022 – 2024',
                    cargo: 'Tesorera Municipal',
                    organo: 'Tezontepec de Aldama, Hidalgo',
                    texto: 'Dirección de la política financiera municipal y control presupuestal; integración de la Cuenta Pública y supervisión del cumplimiento normativo.'
                },
                {
                    id: 3,
                    periodo: '2020 – 2021',
                    cargo: 'Contador General Municipal',
                    organo: 'Tezontepec de Aldama, Hidalgo',
                    texto: 'Presupuesto basado en resultados, armonización contable e integración y solventación de auditorías.'
                },
                {
                    id: 4,
                    periodo: '2020',
                    cargo: 'Asesora Legislativa en materia hacendaria',
                    organo: 'Congreso del Estado de Hidalgo, LXIV Legislatura',
                    texto: 'Análisis del paquete hacendario estatal; evaluación técnica de propuestas financieras para su aprobación legislativa.'
                },
                {
                    id: 5,
                    periodo: '2016 – 2020',
                    cargo: 'Directora de Presupuesto y Contabilidad',
                    organo: 'Pachuca de Soto, Hidalgo',
                    texto: 'Coordinación del sistema contable y presupuestal. Bajo esta gestión, Pachuca pasó del lugar 89 al 7 nacional en el Índice de Información Presupuestal del IMCO.',
                    destacado: true
                },
                {
                    id: 6,
                    periodo: '2006 – 2009',
                    cargo: 'Tesorera Municipal',
                    organo: 'San Agustín Tlaxiaca, Hidalgo',
                    texto: 'Elaboración de Ley de Ingresos y control financiero; manejo integral de la contabilidad gubernamental.'
                },
                {
                    id: 7,
                    periodo: '1999 – 2005',
                    cargo: 'Jefe de Auditoría',
                    organo: 'Secretaría de la Contraloría del Gobierno del Estado de Hidalgo',
                    texto: 'Fiscalización de recursos públicos en municipios y dependencias; evaluación del cumplimiento normativo en el ejercicio del gasto.'
                }
            ]
        }
    }

    render() {
        return (
        <section className="chapter-section section-padding bg-white" id="chapters">
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col-lg-8">
                        <div className="center-heading text-center mb-60">
                            <h3 className="heading-title">Experiencia Profesional de Marlene</h3>
                            <p>Trayectoria cronológica en el servicio público</p>
                        </div>
                    </div>
                </div>

                {/* Línea de tiempo horizontal: se desplaza de izquierda a derecha */}
                <div className="timeline-h">
                    <div className="timeline-h-track">
                        {
                            this.state.trayectoria.map((item) => (
                                <div className={`tl-item${item.destacado ? ' is-star' : ''}`} key={item.id}>
                                    <span className="tl-year">{item.periodo}</span>
                                    <span className="tl-dot"></span>
                                    <div className="tl-card">
                                        <h4 className="tl-role">{item.cargo}</h4>
                                        <span className="tl-org">{item.organo}</span>
                                        <p>{item.texto}</p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </section>
        );
    }
}

export default Chapter;
